export default __webpack_public_path__ + "static/media/oxford fluted panel.61686619.png";